// extracted by mini-css-extract-plugin
export default {"badge":"NotificationBadge_badge__4Mwrp"};